import { createContext, useEffect, useState } from "react"

interface UserI {
    token: string,
    exp: number
}

interface UserContextI {
    user: UserI,
    setUserInfo: (payload: UserI) =>  void
    isTokenAlive: () =>  void
    logOff: () =>  void
}

export const UserContext = createContext({} as UserContextI);

const initialState:UserI = {
    token: '',
    exp:0
}

const UserContextProvider = ({children}:any) => {
    const [user, setUser] = useState<UserI>(initialState);

    useEffect(() => {
        if(localStorage.getItem('@appUser')){
            const storageUser = JSON.parse(localStorage.getItem('@appUser') || "")
            setUser(storageUser);
        }
    },[])

    const setUserInfo = (payload: UserI) => {
        localStorage.setItem('@appUser',JSON.stringify(payload));
        setUser(payload);
    }

    const isTokenAlive = () => {
        const currentTime = Date.now() / 1000
        if (user.exp && user.exp < currentTime) {
            setUser(initialState)
            return false;
          }
          return true;

    }


    const logOff = () => {
        localStorage.setItem('@appUser','');
        setUser(initialState);
    }

    return (
        <UserContext.Provider value={{
            user,
            setUserInfo,
            isTokenAlive,
            logOff
        }}>
            {children}
        </UserContext.Provider>
    )
}

export default UserContextProvider
